
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ImportIconComponent } from "./import-icon.svg";

export const ImportIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ImportIconComponent {...props} />;
};
